/**
 * Campo hidden del form, compilato dal valore di un parametro in
 * querystring (US#77117). Il nome del parametro è quello scritto
 * dal redattore nell'Etichetta del campo (es. "cicciopasticcio" ->
 * legge ?cicciopasticcio=...).
 */
import React from 'react';
import { useLocation } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  placeholder: {
    id: 'querystring_hidden_placeholder',
    defaultMessage: 'URL parameter (hidden): {title}',
  },
  placeholder_no_label: {
    id: 'querystring_hidden_placeholder_no_label',
    defaultMessage: 'URL parameter (hidden), no label set',
  },
});

const QuerystringHiddenWidget = ({ id, name, title, onChange, value }) => {
  const intl = useIntl();
  const location = useLocation();
  const isOnEdit = location.pathname.endsWith('/edit');

  React.useEffect(() => {
    if (!title) {
      return;
    }
    const params = new URLSearchParams(location.search);
    const paramValue = params.get(title);
    if (paramValue && paramValue !== value) {
      onChange(name, paramValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, title]);

  return (
    <>
      {isOnEdit && (
        <input
          id={`${id}-placeholder`}
          name={`${name}-placeholder`}
          type="text"
          value={
            title
              ? intl.formatMessage(messages.placeholder, { title })
              : intl.formatMessage(messages.placeholder_no_label)
          }
          disabled
          readOnly
        />
      )}
      <input type="hidden" id={id} name={name} value={value ?? ''} />
    </>
  );
};

export default QuerystringHiddenWidget;
